import { useNavigate } from 'react-router-dom';
import './logout.css';
import { useAppDispatch } from '../../store/hooks';
import { logout } from '../../store/user/userSlice';
import { removeAllTokens } from '../../helpers/localstorage.helper';

function Logout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logoutHandler = () => {
    dispatch(logout());
    removeAllTokens();
    navigate('/');
  };
  return (
    <div className="logout" onClick={logoutHandler}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.8999 7.56023C9.2099 3.96023 11.0599 2.49023 15.1099 2.49023H15.2399C19.7099 2.49023 21.4999 4.28023 21.4999 8.75023V15.2702C21.4999 19.7402 19.7099 21.5302 15.2399 21.5302H15.1099C11.0899 21.5302 9.2399 20.0802 8.9099 16.5402"
          stroke="#3563E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M15.0001 12H3.62012" stroke="#3563E9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
          stroke="#3563E9"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <button>Выйти</button>
    </div>
  );
}

export default Logout;
